export default {
  addPlugin: {
    method: 'post',
    url: '/client/vehicle/plugin'
  },
  getPluginByVehicleId: {
    method: 'post',
    url: '/client/vehicle/plugin/list/ID'
  },
  removePlugin: {
    method: 'delete',
    url: '/client/vehicle/plugin'
  },
  changeStatus: {
    method: 'put',
    url: '/client/vehicle/plugin/status'
  },
  editPlugin: {
    method: 'put',
    url: '/client/vehicle/plugin/id'
  },
  getDetail: {
    method: 'get',
    url: '/client/vehicle/plugin/ID'
  }
}
